import React from "react"
import s from "./Modal.module.scss"

export default function Modal({ modal }) {
  if (!modal) {
    return null
  }
  let lines = (
    <>
      <span>{modal.line}</span>
      <div>&#62;</div>
    </>
  )

  if (modal.reverse) {
    lines = (
      <>
        <div>&#62;</div>
        <span>{modal.line}</span>
      </>
    )
  }

  if (modal.hideArrow) {
    lines = (
      <>
        <span>{modal.line}</span>
      </>
    )
  }

  if (modal.content) {
    lines = modal.content
  }
  return (
    <div className={s[modal.classNames]}>
      {modal.close && <div className={s.close}></div>}
      {modal.heading && <h2>{modal.heading}</h2>}
      {lines}
      {modal.image && <img src={modal.image} alt={modal.alt} />}
      {modal.heading2 && <h3>{modal.heading2}</h3>}
    </div>
  )
}
